import { render, staticRenderFns } from "./UserControlNia.vue?vue&type=template&id=a2c32f82"
import script from "./UserControlNia.vue?vue&type=script&lang=js"
export * from "./UserControlNia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports